import { IconNotificationCompetence, IconNotificationContract, IconNotificationDiscussion, IconNotificationPerson, IconNotifications } from "../common/icons";

export const notificationIcons = {
  PERSON: () => IconNotificationPerson(),
  CONTRACT: () => IconNotificationContract(),
  COMPETENCE_COURSE: () => IconNotificationCompetence(),
  COMPETENCE_EDUCATION: () => IconNotificationCompetence(),
  COMPETENCE_SKILL: () => IconNotificationCompetence(),
  COMPETENCE_LANGUAGE: () => IconNotificationCompetence(),
  DISCUSSION: () => IconNotificationDiscussion(),
  EQUIPMENT: () => IconNotifications(),
};
